import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {InputSwitch} from "primereact/inputswitch";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Editor} from "primereact/editor";

import CompanyListService from "../../services/company/CompanyListService";
import EntrylocationListCompanyService from "../../services/entrylocation/EntrylocationListCompanyService";
import EntrylocationOwnerInviteComponent from "./EntrylocationOwnerInviteComponent";
import {AutoComplete} from "primereact/autocomplete";
import EntrylocationSubcontractorInviteComponent from "./EntrylocationSubcontractorInviteComponent";
import EntrylocationByNetworkShowService from "../../services/entrylocation/EntrylocationByNetworkShowService";
import NetworkListService from "../../services/network/NetworkListService";
import EntrylocationFormService from "../../services/entrylocation/EntrylocationFormService";
import EntrylocationContactsService from "../../services/entrylocation/EntrylocationContactsService";
import EntrylocationUsersService from "../../services/entrylocation/EntrylocationUsersService";

const EntrylocationByNetworkFormComponent = (props) => {

  const [formData, setFormData] = useState({
    active: true,
    company: {
      id: Number(localStorage.getItem('defaultCompanyId'))
    }
  });
  const [editorValue, setEditorValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    // if (!data.company || !data.company.id || data.company.id === null) {
    //   errors.company = 'Vállalkozás kiválasztása kötelező!';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    data = {
      ...data,
      description: editorValue
    }
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    EntrylocationFormService(data, 'put')
      .then(response => {
        window.App.toastShow('success', 'Sikeres módosítás!');
        window.App.setState({rerenderEntrylocationList: true})
        if (props.closeForm === true) {
          window.App.setState({
            sidebarEntrylocationByNetworkUpdate: false,
          })
        }
        NetworkListService()
          .then(response => {
            if (response.data && response.data[0]) {
              window.App.setState({
                networks: response.data
              })
            }
          })
        setLoading(false)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setLoading(false)
      })
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const [companyFormData, setCompanyFormData] = useState({}); // set on dialog open!

  const companyActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_entry_location_subcontractor_invite') &&
        <Button icon="pi pi-envelope" className="p-button-sm  p-button-info p-mr-2"
                type="button"
                onClick={() => {
                  window.App.setState({dialogEntrylocationSubcontractor: true})
                  setCompanyFormData({
                    ...companyFormData,
                    companyId: rowData.id
                  })
                  window.App.setState({props: formData.id})
                }}/>
        }
      </React.Fragment>
    );
  }

  // company autocomplete
  const [companiesAC, setCompaniescompaniesAC] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(localStorage.getItem('defaultCompanyName'));

  const searchEntryLocation = (event) => {
    CompanyListService(JSON.stringify({filters: {name: {value: event.query}}}))
      .then(response => {
        setCompaniescompaniesAC(response.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  // contact autocomplete
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState();

  const searchContact = (event) => {
    EntrylocationUsersService(formData.id, JSON.stringify({filters: {name: {value: event.query}}}))
      .then(response => {
        if (response.data && response.data.items && response.data.items[0]) {
          let _contacts = []
          response.data.items.map((contact, index) => {
            _contacts.push({
              ...contact,
              name: contact.name + " (" + contact.identifier + ")",
            })
          })
          setContacts(_contacts)
        }
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  // pager
  const [rows, setRows] = useState(10);
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  useEffect(() => {
    setLoading(true)
    EntrylocationByNetworkShowService(localStorage.getItem('networkId'))
      .then(response => {
        setFormData(response.data)
        setEditorValue(response.data.description)
        setSelectedCompany(response.data.companyName)
        setSelectedContact(response.data.contactName)
        EntrylocationListCompanyService(response.data.id, JSON.stringify({
          first: 0,
          rows: 9999,
          page: 0,
        }))
          .then(response => {
            window.App.setState({dataEntrylocationSubcontractors: response.data.items})
            setLoading(false)
          })
          .catch(error => {
            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
            setLoading(false)
          })
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setLoading(false)
      })
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit, submitting}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> Alapadatok
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            {localStorage.getItem('roles').toString().includes('role_entry_location_create') &&
            <>
              <div className={"p-col-12 p-md-4 p-lg-4"}>
                <Field name="name" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="name"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                    <span className={"p-d-block"}>
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-md-4 p-lg-4"}>
                <Field name="company" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="company"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Cég</label>
                    <span className={"p-d-block"}>
                    {localStorage.getItem('roles').toString().includes('role_company_browse')
                    || localStorage.getItem('roles').toString().includes('role_company_read') ? (
                      <AutoComplete value={selectedCompany}
                                    id={"company"}
                                    suggestions={companiesAC}
                                    forceSelection
                                    completeMethod={searchEntryLocation}
                                    field={"name"}
                                    delay="1000"
                                    placeholder={"Keresés gépeléssel..."}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      setFormData({
                                        ...formData,
                                        company: {id: e.value.id}
                                      })
                                      localStorage.setItem('defaultCompanyId', e.value.id)
                                      localStorage.setItem('defaultCompanyName', e.value.name)
                                    }}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        company: {id: null}
                                      })
                                      setSelectedCompany(e.value)
                                    }}
                                    dropdown
                                    onClear={(e) => {
                                      setSelectedCompany('')
                                    }}
                      />
                    ) : (
                      <Dropdown disabled className={"disabled"} id={"company"}/>
                    )}
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-md-2 p-lg-2"}>
                <Field name="active" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="active"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Aktív</label>
                    <span className={"p-d-block"}>
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.active}
                      value={formData.active}
                      onChange={e => setFormData({...formData, active: e.target.value})}/>
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              {localStorage.getItem('roles').toString().includes('role_superadmin') &&
              <>
                <div className={"p-col-12 p-md-2 p-lg-2"}>
                  <Field name="supervised" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="supervised"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>Üvegkapu</label>
                      <span className={"p-d-block"}>
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.supervised}
                      value={formData.supervised}
                      onChange={e => setFormData({...formData, supervised: e.target.value})}/>
                  </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {/*<div className={"p-col-12 p-md-4 p-lg-4"}>*/}
                {/*  <Field name="localUnitIP" render={({input, meta}) => (*/}
                {/*    <div className="p-field p-fluid">*/}
                {/*      <label htmlFor="localUnitIP"*/}
                {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>Központi vezérlő IP címe</label>*/}
                {/*      <span className={"p-d-block"}>*/}
                {/*      <InputText id="localUnitIP" {...input}*/}
                {/*                 onChange={(e) => {*/}
                {/*                   setFormData({*/}
                {/*                     ...formData,*/}
                {/*                     localUnitIP: e.target.value*/}
                {/*                   })*/}
                {/*                 }}*/}
                {/*                 value={formData.localUnitIP}*/}
                {/*                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
                {/*    </span>*/}
                {/*      {getFormErrorMessage(meta)}*/}
                {/*    </div>*/}
                {/*  )}/>*/}
                {/*</div>*/}
              </>
              }
            </>
            }
            {localStorage.getItem('roles').toString().includes('role_entry_location_description') &&
            <>
              {formData && formData.id &&
              <div className={"p-col-12 p-md-4 p-lg-4"}>
                <Field name="contact" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="contact"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Kapcsolattartó</label>
                    <span className={"p-d-block"}>
                      <AutoComplete value={selectedContact}
                                    id={"contact"}
                                    suggestions={contacts}
                                    forceSelection
                                    completeMethod={searchContact}
                                    field={"name"}
                                    delay="1000"
                                    placeholder={"Keresés gépeléssel..."}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      setFormData({
                                        ...formData,
                                        contact: {id: e.value.id}
                                      })
                                    }}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        contact: {id: null}
                                      })
                                      setSelectedContact(e.value)
                                    }}
                                    dropdown
                                    onClear={(e) => {
                                      setSelectedContact('')
                                    }}
                      />
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              }
              <div className={"p-col-12"}>
                <Field name="description" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="description"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Leírás</label>
                    <span className={"p-d-block"}>
                    <Editor style={{height: '320px'}} value={editorValue}
                            onTextChange={(e) => {
                              setEditorValue(e.htmlValue)
                            }}/>
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </>
            }
          </div>
          <div className={"p-grid p-mt-3"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              {(props && props.initialValues || formData.id) && localStorage.getItem('roles').toString().includes('role_entry_location_invite') &&
              <Button type="button" label="Meghívás" icon={"pi pi-envelope"}
                      className="p-button-info p-button-highlighted"
                      onClick={() => {
                        window.App.setState({props: props.initialValues.id})
                        window.App.setState({dialogEntrylocationOwner: true})
                      }}
              />
              }
              {formData.id && !props.getBy &&
              <Button type="button" label="Megtekintés" icon={"pi pi-eye"}
                      onClick={() => {
                        window.App.setState({
                          props: formData,
                          sidebarEntrylocationByNetworkUpdate: false,
                          sidebarEntrylocationByNetworkShow: true,
                        })
                      }}
                      className="p-button p-ml-2"/>
              }
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label="Mentés és bezár" icon={"pi pi-check"}
                      loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: true}
                      }}
                      className="p-button-success"/>
              <Button type="submit" label="Mentés" icon={"pi pi-check"}
                      loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: false}
                      }}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </Panel>
        {/*<BlockUI blocked={Boolean(!formData.id)} template={<i className="pi pi-lock" style={{'fontSize': '3rem'}}/>}>*/}
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> Közreműködők
              </h3>
            </div>
          </div>
        } className={"p-mt-3"}>
          {(formData && formData.id) || (props.initialValues && props.initialValues.id) ? (
            <>
              {window.App.state.dataEntrylocationSubcontractors && window.App.state.dataEntrylocationSubcontractors[0] &&
              <DataTable value={window.App.state.dataEntrylocationSubcontractors}
                         emptyMessage="Nincs találat."
                         autoLayout={true}
                         filterDisplay="row"
                         responsiveLayout="scroll"
                         stripedRows
                         className={"p-mb-3"}
                         paginator
                         paginatorTemplate={pager}
                         rows={rows}
              >
                {/*<Column body={companyActionBodyTemplate} className={"p-py-0 p-text-nowrap"}></Column>*/}
                <Column field="companyName" header="Név"></Column>
              </DataTable>
              }
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6 p-col-align-center"}>
                  {window.App.state.dataEntrylocationSubcontractors && !window.App.state.dataEntrylocationSubcontractors[0] &&
                  <>Nincs közreműködő.</>
                  }
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                  {localStorage.getItem('roles').toString().includes('role_entry_location_subcontractor_invite') &&
                  <Button type="button" label="Meghívás" icon="pi pi-envelope"
                          className="p-button-info p-button-highlighted"
                          onClick={() => {
                            window.App.setState({dialogEntrylocationSubcontractor: true})
                            setCompanyFormData({
                              ...companyFormData,
                              companyId: formData.id
                            })
                            window.App.setState({props: formData.id})
                          }}

                  />
                  }
                </div>
              </div>
            </>
          ) : (
            <><i className={"pi pi-lock"}></i> A közreműködők megtekintése csak mentés után lehetséges!</>
          )}
        </Panel>
        {/*</BlockUI>*/}
        <Dialog visible={window.App.state.dialogEntrylocationOwner}
                style={{width: '750px'}}
                header="Fővállalkozó meghívása"
                modal
                onHide={() => {
                  window.App.setState({dialogEntrylocationOwner: false})
                }}>
          <EntrylocationOwnerInviteComponent/>
        </Dialog>
        <Dialog visible={window.App.state.dialogEntrylocationSubcontractor}
                style={{width: '750px'}}
                header="Közreműködő meghívása"
                modal
                onHide={() => {
                  window.App.setState({dialogEntrylocationSubcontractor: false})
                  EntrylocationListCompanyService(formData.id)
                    .then(response => {
                      window.App.setState({dataEntrylocationSubcontractors: response.data.items})
                    })
                    .catch(error => {
                      window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                    })
                }}>
          <EntrylocationSubcontractorInviteComponent/>
        </Dialog>
      </form>
    )}/>
  )
}
export default withTranslation('common')(EntrylocationByNetworkFormComponent);
